/**
 * Centralized translation and label mapping for fleet-related terms
 * Ensures consistent Portuguese translations across the entire application
 */

export const ALERT_TYPE_LABELS: Record<string, string> = {
  'document_expiry': 'Vencimento de Documento',
  'fuel_consumption': 'Consumo de Combustível',
  'high_mileage': 'Alta Quilometragem',
  'maintenance_overdue': 'Manutenção Atrasada',
  'maintenance_due': 'Manutenção Próxima',
  'maintenance': 'Manutenção',
  'document': 'Documento',
  'fuel': 'Combustível',
  'violation': 'Infração',
  'system': 'Sistema',
};

export const PRIORITY_LABELS: Record<string, string> = {
  'low': 'Baixa',
  'medium': 'Média',
  'high': 'Alta',
  'critical': 'Crítica',
};

export const STATUS_LABELS: Record<string, string> = {
  'active': 'Ativo',
  'inactive': 'Inativo',
  'maintenance': 'Em Manutenção',
  'open': 'Em Andamento',
  'in_progress': 'Em Andamento',
  'closed': 'Concluído',
  'pending': 'Pendente',
  'completed': 'Completo',
  'cancelled': 'Cancelado',
  'resolved': 'Resolvido',
  'acknowledged': 'Reconhecido',
};

export const FUEL_TYPE_LABELS: Record<string, string> = {
  'gasoline': 'Gasolina Comum',
  'gasoline_premium': 'Gasolina Aditivada',
  'ethanol': 'Etanol',
  'diesel': 'Diesel Comum',
  'diesel_s10': 'Diesel S10',
  'gnv': 'GNV',
  'flex': 'Flex',
  'electric': 'Elétrico',
  'hybrid': 'Híbrido',
  'cng': 'GNV',
};

export const VEHICLE_CATEGORY_LABELS: Record<string, string> = {
  'car': 'Carro',
  'truck': 'Caminhão',
  'van': 'Van',
  'motorcycle': 'Moto',
  'bus': 'Ônibus',
  'trailer': 'Reboque',
};

// Helper functions with automatic capitalization
export function getAlertTypeLabel(type: string): string {
  const label = ALERT_TYPE_LABELS[type?.toLowerCase()] || type;
  return capitalizeFirst(label);
}

export function getPriorityLabel(priority: string): string {
  const label = PRIORITY_LABELS[priority?.toLowerCase()] || priority;
  return capitalizeFirst(label);
}

export function getStatusLabel(status: string): string {
  const label = STATUS_LABELS[status?.toLowerCase()] || status;
  return capitalizeFirst(label);
}

export function getFuelTypeLabel(fuelType: string): string {
  const label = FUEL_TYPE_LABELS[fuelType?.toLowerCase()] || fuelType;
  return capitalizeFirst(label);
}

export function getVehicleCategoryLabel(category: string): string {
  const label = VEHICLE_CATEGORY_LABELS[category?.toLowerCase()] || category;
  return capitalizeFirst(label);
}

// Utility: Capitalize first letter
function capitalizeFirst(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}
